import React, { useState } from "react";
import { Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";

import { changePassword } from "../../redux/slices/authSlice";
import Toast from "../../Hooks/useToast";
import styles from "./styles/ChangePassword.module.scss";

export default function ChangePassword() {
  const dispatch = useDispatch();
  const changePasswordLoading = useSelector(
    (state) => state.auth.changePasswordLoading
  );
  const { handleSubmit, register, reset } = useForm();
  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const handleDataSubmission = async (values) => {
    const current_password = values.current_password?.trim() ?? "";
    const new_password = values.new_password ?? "";
    const confirm_password = values.confirm_password ?? "";

    if (!current_password) {
      Toast("Please enter your current password", "error");
      return;
    }
    if (!new_password) {
      Toast("Please enter a new password", "error");
      return;
    }
    if (new_password !== confirm_password) {
      Toast("New password and confirmation do not match", "error");
      return;
    }

    try {
      await dispatch(
        changePassword({
          current_password,
          new_password,
          confirm_password,
        })
      ).unwrap();
      Toast("Password changed successfully", "success");
      reset();
    } catch (err) {
      const msg =
        err?.body?.message ??
        err?.data?.message ??
        err?.body?.data?.message ??
        err?.message ??
        "Failed to change password";
      Toast(msg, "error");
    }
  };

  return (
    <div className={styles.ChangePassword}>
      <h2 className={styles.heading}>Change Password</h2>
      <p className={styles.sub}>
        Update your password regularly to maintain account security and prevent
        unauthorized access.
      </p>
      <Form onSubmit={handleSubmit(handleDataSubmission)}>
        <div className={styles.form}>
          <div className={styles.field}>
            <label className={styles.label} htmlFor="current_password">
              Current Password
            </label>
            <div className={styles.passwordWrap}>
              <Form.Control
                id="current_password"
                className={styles.input}
                placeholder="Current Password"
                type={showCurrent ? "text" : "password"}
                autoComplete="current-password"
                {...register("current_password")}
              />
              <button
                type="button"
                className={styles.togglePw}
                onClick={() => setShowCurrent((v) => !v)}
                aria-label={showCurrent ? "Hide password" : "Show password"}
              >
                {showCurrent ? <FaEyeSlash size={18} /> : <FaEye size={18} />}
              </button>
            </div>
          </div>

          <p className={styles.sectionLabel}>Set New Password</p>

          <div className={styles.field}>
            <label className={styles.label} htmlFor="new_password">
              New Password
            </label>
            <div className={styles.passwordWrap}>
              <Form.Control
                id="new_password"
                className={styles.input}
                placeholder="New Password"
                type={showNew ? "text" : "password"}
                autoComplete="new-password"
                {...register("new_password")}
              />
              <button
                type="button"
                className={styles.togglePw}
                onClick={() => setShowNew((v) => !v)}
                aria-label={showNew ? "Hide password" : "Show password"}
              >
                {showNew ? <FaEyeSlash size={18} /> : <FaEye size={18} />}
              </button>
            </div>
          </div>

          <div className={styles.field}>
            <label className={styles.label} htmlFor="confirm_password">
              Confirm Password
            </label>
            <div className={styles.passwordWrap}>
              <Form.Control
                id="confirm_password"
                className={styles.input}
                placeholder="Confirm Password"
                type={showConfirm ? "text" : "password"}
                autoComplete="new-password"
                {...register("confirm_password")}
              />
              <button
                type="button"
                className={styles.togglePw}
                onClick={() => setShowConfirm((v) => !v)}
                aria-label={showConfirm ? "Hide password" : "Show password"}
              >
                {showConfirm ? <FaEyeSlash size={18} /> : <FaEye size={18} />}
              </button>
            </div>
          </div>

          <ul className={styles.hintList}>
            <li>At least 12 characters long but 14 or more is better.</li>
            <li>
              A combination of uppercase letters, lowercase letters, numbers,
              and symbols.
            </li>
          </ul>

          <button
            type="submit"
            className={styles.submitBtn}
            disabled={changePasswordLoading}
          >
            {changePasswordLoading ? "Changing…" : "Change Password"}
          </button>
        </div>
      </Form>
    </div>
  );
}
